// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "\n.defaut-champ[data-v-b48e8138] { display: inline-flex; align-items: center; gap: 4px; margin-top: 3px; font-size: 12px; color: #8a5a00; white-space: nowrap;\n}\n.defaut-champ__retablir[data-v-b48e8138] { border: 1px solid #e0c27a; background: #fff8e6; color: #8a5a00; border-radius: 4px; padding: 0 5px; line-height: 18px; font-size: 13px; cursor: pointer;\n}\n.defaut-champ__retablir[data-v-b48e8138]:hover { background: #ffecb8;\n}\n", ""]);
// Exports
module.exports = exports;
